// Components
import FavoriteGameList from "components/organisms/FavoriteGameList";

// Selectors
import { gamesApi } from "redux/game/api";
import { FavoritesResponseType } from "types/Games";

const FavoriteGameListContainer = () => {
  const { data } = gamesApi.useFavoritesQuery();

  const favoriteGames = (data as FavoritesResponseType)?.favoriteGames || data;

  return <FavoriteGameList list={favoriteGames} />;
};

export default FavoriteGameListContainer;
